























































import { defineComponent } from '@vue/composition-api'
import PlayerCardParts from '@/components/common/card/PlayerCardParts.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'

/**
 * フィールドセット お気に入り選手選択 バーツ
 * todo: デザイン調整 / 選手選択ページ遷移処理 / props設定 / エラー表示 / emit等
 */
export default defineComponent({
  name: 'FieldsetFavoritePlayerParts',
  components: {
    PlayerCardParts,
    AtomRouterButton,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * 遷移先リンク
     */
    linkTo: {
      type: String,
      required: true,
    },
    /**
     * お気に入り選手名
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * お気に入り選手画像
     */
    img: {
      type: String,
    },
  },
})
